import React from 'react'
import { Box } from '@mui/material'
import DocumentiForm from './DocumentiForm'
import { useSelector } from 'react-redux'
export const DocumentiSlider = ({cantine, setCantine}) => {
    const singleData = useSelector((state) => state.documenti?.singleDocumenti[0])
    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Registra un Documento</h2>
            </Box>
           <DocumentiForm cantine={cantine} setCantine={setCantine} singleData={singleData}/>
        </Box>
    )
}